// Champion ("legend" in the sim) strings — English. Merged in ./messages.ts.
// The UI says Champion; the sim and wire say legend.

export const gameLegendsEn = {
  'champion.title': 'Champion',
  'champion.kind.dragon': 'Dragon',
  'champion.level': 'Level {level}/{max}',
  'champion.kills': '{kills} kills',
  'champion.nextLevel': 'Next level at {kills} kills',
  'champion.maxLevel': 'Max level',
  'champion.hp': 'Health',
  'champion.rival': 'Rival Champion',
  'champion.ability.firestorm': 'Firestorm',
  'champion.ability.firestormHint':
    'Rain fire on a hex up to {range} tiles away (radius {radius}).',
  'champion.ability.ready': 'Ready',
  'champion.ability.cooldown': 'Recharging {seconds}s',
  'champion.ability.targeting': 'Pick a target hex (Esc to cancel)',
  'champion.ability.cancel': 'Cancel',
  'champion.err.on_cooldown': 'Still recharging.',
  'champion.err.out_of_range': 'Target is out of range.',
  'champion.err.not_owner': 'Not your Champion.',
  'champion.err.not_a_legend': 'That unit is not a Champion.',
  'champion.err.no_such_slot': 'No such ability.',
  'champion.err.module_off': 'Champions are off in this match.',
  'champion.err.unavailable': 'The simulation is not ready.',
  'champion.err.rejected': 'The ability was rejected.',
  'champion.hint.notAtWar':
    'That hit nothing: these units belong to a player you are not at war with. Champion abilities only affect enemies at war with you or raiders.',
  'champion.summon.title': 'Summon Champion',
  'champion.summon.blurb': 'A Champion answers the call of a great city. One Champion at a time.',
  'champion.summon.button': 'Summon {kind}',
  'champion.site.dragon_roost': 'Dragon Roost',
  'champion.summon.cost': 'Cost: {gold} gold, {rare} mana, {pop} population.',
  'champion.summon.costFaith': 'Cost: {gold} gold, {rare} faith, {pop} population.',
  'champion.summon.recost': 'Re-summon at {pct}% of the original cost.',
  'champion.summon.progress': 'Summoning... {pct}%',
  'champion.summon.eta': '{time} left',
  'champion.summon.elsewhere': 'A Champion is being summoned in another city.',
  'champion.summon.alive': 'Your Champion walks the realm. Select it from the map.',
  'champion.summon.fallen': 'Your Champion has fallen. It can be re-summoned in {time}.',
  'champion.summon.requirements': 'Requirements',
  'champion.req.available': 'No Champion active',
  'champion.req.doctrine': '{doctrines} doctrine tier {need} (now {have})',
  'champion.req.cityTier': 'City tier {need} or higher (now {have})',
  'champion.req.cityTierFirst': 'City tier {need} or higher (first summon only)',
  'champion.req.site': '{site} built in this city',
  'champion.req.pop': 'City population {have} / {need}',
  'champion.req.gold': 'Gold {have} / {need}',
  'champion.req.rare': 'Mana {have} / {need}',
  'champion.req.rareFaith': 'Faith {have} / {need}',
  'champion.block.available': 'A Champion is already active or recovering.',
  'champion.block.doctrine': 'Needs a higher {doctrines} doctrine.',
  'champion.block.cityTier': 'This city is too small.',
  'champion.block.site': 'Build a {site} here first.',
  'champion.block.pop': 'This city does not have enough population.',
  'champion.block.gold': 'Not enough gold.',
  'champion.block.rare': 'Not enough mana.',
  'champion.block.rareFaith': 'Not enough faith.',
  'champion.summon.err.cannot_afford': 'Not enough mana or faith for the summoning.',
  'champion.summon.err.no_summoning_site': 'Build the summoning site here first.',
  'champion.summon.err.city_too_small': 'This city is too small.',
  'champion.summon.err.doctrine_locked': 'Needs a higher doctrine.',
  'champion.summon.err.not_available': 'A Champion is already active or recovering.',
  'champion.summon.err.not_owner': 'Not your city.',
  'champion.summon.err.rejected': 'The summoning was rejected.',
  'event.legendSummonStarted': 'Champion summoning',
  'event.legendFirestorm': 'Firestorm',
  'event.legendSummoned': 'Champion summoned',
  'event.legendFallen': 'Champion fallen',
  'event.detail.legendSummonStarted': 'Player {player} begins a summoning',
  'event.detail.legendFirestorm': '{hits} hit, {kills} slain',
  'event.detail.legendSummoned': 'Player {player}: the {kind} has arrived',
  'event.detail.legendFallen': 'Player {player}: back in {seconds}s',
} as const;
